<template>
  <label class="form-checkbox" role="group">
    <input
      :id="id"
      type="checkbox"
      class="form-checkbox__native-input"
      :disabled="disabled"
      value="model"
      :aria-label="label"
      :aria-checked="modelValue"
      :aria-describedby="description ? `${id}-description` : undefined"
      @blur="$emit('blur', $event)"
    />
    <div
      class="form-checkbox__custom-input"
      :class="{
        'form-checkbox__custom-input--checked': modelValue,
      }"
      role="presentation"
      @click="model = !model"
    >
      <CheckIcon v-show="modelValue" class="form-checkbox__checkmark" />
    </div>
    <span class="form-checkbox__label" @click="model = !model">
      <slot />
    </span>
    <span v-if="description" :id="`${id}-description`" class="sr-only">
      {{ description }}
    </span>
  </label>
</template>

<script setup lang="ts">
import CheckIcon from '~/assets/icons/check-generic.svg?component'
import { useUniqueId } from '@/composables/useUniqueId'

withDefaults(
  defineProps<{
    label?: string
    disabled?: boolean
    id?: string
    description?: string
  }>(),
  {
    id: () => useUniqueId('checkbox').value,
    label: undefined,
    disabled: false,
    description: undefined,
  }
)

defineEmits<{
  blur: [event: FocusEvent]
}>()

const model = defineModel<boolean>()
</script>

<style lang="postcss" scoped>
.form-checkbox {
  @apply flex items-start gap-2;

  &__native-input {
    @apply sr-only;
  }

  &__custom-input {
    @apply box-border flex h-5 w-5 min-w-[20px] items-center justify-center border border-gray-300 rounded bg-white transition-colors duration-150 ease-linear;

    &--checked {
      @apply border-teal-600 bg-teal-600;
    }
  }

  &__checkmark {
    @apply w-3.5 h-3.5 text-white flex items-center justify-center;
  }

  &__label {
    @apply text-sm text-gray-700 leading-tight;
  }
}
</style>
